import { useTranslations } from "next-intl";
import { Link, Image } from "@components/core";
import GiftCardExpandable from "./GiftCardExpandable";
import GiftCardOptionsList from "./GiftCardOptionsList";

const GiftCardMenu = () => {
  const t = useTranslations("gift_cards");

  return (
    <div>
      <div className="w-100 position-relative">
        <Image
          src="giftCardMobile"
          alt={t("alt_box")}
          className="w-100 d-md-none"
        />
        <Image
          src="giftCardDesktop"
          alt={t("alt_box")}
          className="d-none d-md-block w-100"
        />
        <div className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center" style={{ top: 0 }}>
          <h1 className="h2 mb-0 text-center text-white">{t("gift_cards_title")}</h1>
        </div>
      </div>
      <div className="gift-card-container">
        <div>
          <div className="gift-card-select-container">
            <p className="gift-card-subtitle-container mb-2">{t("gift_cards_subtitle")}</p>
          </div>
          <GiftCardOptionsList />
          <div className="text-center mb-3">
            <Link
              href="/activate_gift_cards"
              className="link-dark"
            >
              {t("activate_my_gift_card")}
            </Link>
          </div>
        </div>
      </div>

      <div className="gift-card-faq-container">
        <h5 className="mt-4 pb-2 text-center">{t("faq_title")}</h5>

        <GiftCardExpandable title={t("how_it_works.title")}>
          <>
            <p className="mb-0">
              {t("how_it_works.select_amount")}
            </p>
            <p className="mb-0">
              {t("how_it_works.mail_reception")}
            </p>
            <p>
              {t("how_it_works.activable_gift")}
            </p>
          </>
        </GiftCardExpandable>

        <GiftCardExpandable title={t("validity_period")}>
          <p>
            {t("validity_period_details")}
          </p>
        </GiftCardExpandable>

        <GiftCardExpandable title={t("how_change_subscription_plan.title")}>
          <p>
            {t("how_change_subscription_plan.choice_of_subscription")}
          </p>
        </GiftCardExpandable>

        <GiftCardExpandable title={t("how_activate_gift_card.title")}>
          <>
            <p className="mb-0">
              <span>{t("how_activate_gift_card.go_to")}</span>
              <span>
                <Link
                  href="/activate_gift_cards"
                  className="link-primary"
                >
                  {t("how_activate_gift_card.link")}
                </Link>
              </span>
            </p>
            <p>
              {t("how_activate_gift_card.enter_the_code")}
            </p>
          </>
        </GiftCardExpandable>

        <GiftCardExpandable title={t("how_to_use_gift_card.title")}>
          <>
            <p className="mb-0">
              <span>{t("how_to_use_gift_card.go_to")}</span>
              <span>
                <Link
                  href="/activate_gift_cards"
                  className="link-primary"
                >
                  {t("how_to_use_gift_card.link")}
                </Link>
              </span>
            </p>
            <p className="mb-0">
              {t("how_to_use_gift_card.credit_applications")}
            </p>
            <p>
              {t("how_to_use_gift_card.credit_not_application")}
            </p>
          </>
        </GiftCardExpandable>
      </div>
    </div>
  );
};

export default GiftCardMenu;
